import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import * as Languages from '../constants/Languages';
export const getPreferredLanguage = () => {
  const navigator = window.navigator;
  const preferredLanguage = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '';
  return preferredLanguage;
};
export const getI18nLanguage = () => {
  // @ts-expect-error dependency missing types
  const lang = I18n.loaded && I18n.locale ? getLang() : Languages.EN;
  return lang;
};
export const I18nLookup = val => {
  // @ts-expect-error dependency missing types
  return I18n.lookup(val);
};